import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommentAuthorType, SupportMessage } from 'src/app/common/models/support/SupportMessage';

@Pipe({
    name: 'authorLabel',
    standalone: false
})
export class AuthorLabelPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(message: SupportMessage): string {
    return message.authorType === CommentAuthorType.Member || message.authorType === CommentAuthorType.System
      ? message.authorLabel
      : this.translate.instant('support_popup.case.lbl_support_label');
  }
}
